(function () {
  'use strict';

  if (window.location.pathname.replace(/\/+$/, '') !== '/pages/lp' || window.__lvnLpCartInstalled) return;
  window.__lvnLpCartInstalled = true;

  var rootSelector = '#replo-fullpage-element, #alchemy-fullpage-element, [data-alchemy-element-root]';
  var buttonSelector = '[data-replo-add-product-variant-to-cart]';
  var statuses = new WeakMap();
  var pending = false;
  var reviewRequired = false;
  var cartUrl = '/cart';

  function landingRoot() {
    return document.querySelector(rootSelector);
  }

  function buttonFrom(target) {
    if (!target || typeof target.closest !== 'function') return null;
    var button = target.closest(buttonSelector);
    var root = landingRoot();
    return button && root && root.contains(button) ? button : null;
  }

  function statusFor(button) {
    var status = statuses.get(button);
    if (!status) {
      status = document.createElement('p');
      status.setAttribute('data-lvn-lp-cart-status', '');
      status.setAttribute('aria-live', 'polite');
      status.setAttribute('role', 'status');
      button.insertAdjacentElement('afterend', status);
      statuses.set(button, status);
    }
    return status;
  }

  function showStatus(button, message, error) {
    var status = statusFor(button);
    status.setAttribute('role', error ? 'alert' : 'status');
    status.textContent = message;
    if (error) {
      var link = document.createElement('a');
      link.href = cartUrl;
      link.textContent = ' Vérifier mon panier';
      status.appendChild(link);
    }
  }

  function formProperties(root, variantId) {
    var properties = {};
    Array.from(root.querySelectorAll('form[action*="/cart/add"]')).forEach(function (form) {
      var formData = new FormData(form);
      if (String(formData.get('id')) !== String(variantId)) return;
      formData.forEach(function (value, name) {
        var propertyName = name.match(/^properties\[(.+)\]$/);
        if (propertyName && typeof value === 'string') properties[propertyName[1]] = value;
      });
    });
    return properties;
  }

  function selectedItems(root) {
    var widget = root.querySelector('kaching-bundles-block');
    if (!widget || typeof widget.items !== 'function') {
      throw new Error('Les options de votre offre ne sont pas encore prêtes. Patientez quelques secondes.');
    }
    if (typeof widget.validateItemSelection === 'function') {
      var validation = widget.validateItemSelection();
      if (validation && validation.valid === false) throw new Error('Sélectionnez les options de chaque article.');
    } else if (typeof widget.isItemSelectionValid === 'function' && !widget.isItemSelectionValid()) {
      throw new Error('Sélectionnez les options de chaque article.');
    }
    if (typeof widget.rotateBundleNonce === 'function') widget.rotateBundleNonce();
    var items = widget.items();
    if (!Array.isArray(items) || items.length === 0) throw new Error('Sélectionnez votre offre avant de l’ajouter au panier.');

    return items.map(function (item) {
      if (!item || !/^\d+$/.test(String(item.id)) || Number(item.id) <= 0 ||
          !Number.isInteger(Number(item.quantity)) || Number(item.quantity) < 1) {
        throw new Error('Les options de votre offre sont incomplètes. Vérifiez vos tailles et couleurs.');
      }
      if (item.properties != null && (typeof item.properties !== 'object' || Array.isArray(item.properties))) {
        throw new Error('Votre offre ne peut pas être confirmée. Actualisez la page avant de réessayer.');
      }
      var selected = {
        id: String(item.id),
        quantity: Number(item.quantity),
        properties: Object.assign({}, formProperties(root, item.id), item.properties || {})
      };
      if (item.selling_plan) selected.selling_plan = item.selling_plan;
      if (item.parent_id) selected.parent_id = item.parent_id;
      return selected;
    });
  }

  async function addSelection(button) {
    if (pending) return;
    if (reviewRequired) {
      window.location.assign(cartUrl);
      return;
    }
    var previousDisabled = button.disabled;
    var previousAriaDisabled = button.getAttribute('aria-disabled');
    var previousAriaBusy = button.getAttribute('aria-busy');
    var operations = window.LuveonCartOperations;
    var lockAcquired = false;
    var acquiringLock = false;
    pending = true;
    var accepted = false;
    var postStarted = false;
    var rejectionMessage = '';
    var timer;

    try {
      if (operations && typeof operations.begin === 'function' && typeof operations.end === 'function') {
        acquiringLock = true;
        lockAcquired = operations.begin();
        acquiringLock = false;
        if (!lockAcquired) {
          showStatus(button, 'Le panier est en cours de mise à jour. Réessayez dans un instant.', false);
          return;
        }
      }
      button.disabled = true;
      button.setAttribute('aria-disabled', 'true');
      button.setAttribute('aria-busy', 'true');
      showStatus(button, 'Ajout au panier en cours…', false);
      var root = landingRoot();
      var payload = { items: selectedItems(root) };
      var drawer = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
      var sections = drawer && typeof drawer.getSectionsToRender === 'function' ? drawer.getSectionsToRender() : [];
      var sectionIds = sections.map(function (section) { return section.id; }).filter(Boolean);
      if (sectionIds.length) {
        payload.sections = sectionIds;
        payload.sections_url = window.location.pathname;
      }
      if (drawer && typeof drawer.setActiveElement === 'function') drawer.setActiveElement(button);
      var controller = new AbortController();
      timer = setTimeout(function () { controller.abort(); }, 20000);
      postStarted = true;
      var response = await window.fetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify(payload),
        signal: controller.signal
      });
      var result = await response.json();
      if (!response.ok || result.status) {
        rejectionMessage = result.description || result.message || '';
        throw new Error('Ajout non confirmé.');
      }
      if (!Array.isArray(result.items) || !result.items.length) throw new Error('Ajout non confirmé. Vérifiez votre panier avant de réessayer.');
      accepted = true;
      clearTimeout(timer);
      var canRender = drawer && typeof drawer.renderContents === 'function' && sectionIds.length &&
        result.sections && sectionIds.every(function (sectionId) { return typeof result.sections[sectionId] === 'string'; });
      if (canRender) {
        drawer.classList.remove('is-empty');
        await drawer.renderContents(result);
        showStatus(button, 'Votre sélection a été ajoutée au panier.', false);
      } else {
        window.location.assign(cartUrl);
      }
    } catch (error) {
      if (accepted) {
        window.location.assign(cartUrl);
      } else {
        var message;
        if (postStarted) {
          reviewRequired = true;
          message = (rejectionMessage ? rejectionMessage + ' ' : '') + 'Ajout non confirmé. Vérifiez votre panier avant de réessayer. Le prochain clic ouvrira votre panier.';
        } else if (acquiringLock) {
          reviewRequired = true;
          message = 'Le panier est temporairement indisponible. Vérifiez votre panier avant de continuer.';
        } else {
          message = error instanceof Error && error.message && !['AbortError', 'TypeError', 'SyntaxError'].includes(error.name) ?
            error.message : 'Ajout non confirmé. Vérifiez votre panier avant de réessayer.';
        }
        showStatus(button, message, true);
      }
    } finally {
      clearTimeout(timer);
      pending = false;
      try {
        if (lockAcquired) operations.end();
      } catch (releaseError) {
        reviewRequired = true;
        showStatus(button, accepted ? 'Votre sélection a été ajoutée. Vérifiez votre panier avant de continuer.' :
          'Le panier doit être vérifié avant de continuer. Le prochain clic ouvrira votre panier.', true);
      } finally {
        button.disabled = previousDisabled;
        if (previousAriaDisabled === null) button.removeAttribute('aria-disabled');
        else button.setAttribute('aria-disabled', previousAriaDisabled);
        if (previousAriaBusy === null) button.removeAttribute('aria-busy');
        else button.setAttribute('aria-busy', previousAriaBusy);
      }
    }
  }

  function handleClick(event) {
    var button = buttonFrom(event.target);
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    return addSelection(button);
  }

  function handleSubmit(event) {
    var button = buttonFrom(event.submitter);
    if (!button) {
      var root = landingRoot();
      if (!root || !root.contains(event.target) || !event.target.matches('form[action*="/cart/add"]')) return;
      button = root.querySelector(buttonSelector);
    }
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    return addSelection(button);
  }

  document.addEventListener('click', handleClick, true);
  document.addEventListener('submit', handleSubmit, true);
})();
